require(
  [
    'fastdom',
    'galleryPageImagesHandler',
    'builderShowcaseObserver'
  ],
  (fastdom, galleryPageImagesHandler, builderShowcaseObserver) => {
    'use strict';

    /**
   * Used to switch the data attribute used to determine which tab is currently active.
   * @param {*} activeButton the button element that contains each tab.
   */
    function toggleActiveTab(activeButton) {
      const buttons = document.querySelectorAll('[data-gallery-button]');

      buttons.forEach((button) => {
        button.removeAttribute('data-active-tab');
        button.classList.remove('btn--active');
      });

      activeButton.setAttribute('data-active-tab', true);
      activeButton.classList.add('btn--active');
    }

    /**
   * Sets the new active category into state
   * @param {string} category the new active category
   */
    function setActiveTab(category) {
      builderShowcaseObserver.setData({
        activeCategory: category,
        activeCategoryCurrentPage: 1,
      });

      builderShowcaseObserver.commit();
    }

    /**
   * Used to scroll the active tab into the device's viewport
   * @param {*} container the container element
   * @param {*} button the currently active button
   */
    function scrollTabIntoView(container, button) {
      const index = button.dataset.index;

      fastdom.mutate(() => {
        const buttonSize = button.clientWidth;
        if (buttonSize && index) {
          const position = index * buttonSize;
          container.scrollTo({ left: position, top: 0, behavior: 'smooth' });
        }
      });
    }

    /**
   * Inits the tab handling functionality
   */
    function init() {
      const container = document.querySelector('[data-gallery-tabs]');

      container.addEventListener('click', (event) => {
        const target = event.target;
        const button = target.closest('button');

        if (!button || button.disabled) {
          return;
        }

        if (!container.classList.contains('button-nav--thumbs')) {
          container.querySelectorAll('[data-gallery-image]').forEach((element) => {
            const figure = element;
            figure.dataset.gaEventCategory = 'Builder-Gallery-Pages';
            figure.dataset.gaEventAction = 'List-view-menu-buttons';
            figure.dataset.ga4EventName = 'showcase_events';
            figure.dataset.ga4EventClick_target = 'Gallery list menu';
            figure.dataset.ga4EventClick_target1 = figure.innerText;
          });
        }

        container.classList.remove('button-nav--thumbs');
        const isCurrentlyActive = button.dataset.activeTab === true;

        if (!isCurrentlyActive) {
          container.classList.remove('button-nav--thumbs');
          toggleActiveTab(button);

          const category = button.dataset.collection;
          container.classList.add('navigation--selected');

          setActiveTab(category);
          scrollTabIntoView(container, button);
          galleryPageImagesHandler.createImageCollection(category);
        }
      });
    }

    init();
  }
);

define("galleryPageTabsHandler", function(){});

